// 1. External libraries
import { Link } from '@tanstack/react-router';

// 2. Internal components
import { CenteredAuthLayout } from '~/components/common/CenteredAuthLayout';
import { Alert, AlertDescription, AlertTitle } from '~/components/ui/alert';
import { Button } from '~/components/ui/button';

/**
 * Terminal page for sign-in attempts that need a verification step this app
 * does not support. Offers a plain link back to sign in.
 */
export function AuthContinuePage() {
  return (
    <CenteredAuthLayout data-testid="auth-continue-container" contentWidth="wide">
      <Alert variant="warning" className="mb-6">
        <AlertTitle>Additional Verification Not Supported</AlertTitle>
        <AlertDescription>
          This account needs additional verification, which is not supported here. Go back to sign
          in and try another sign-in method.
        </AlertDescription>
      </Alert>

      <Button size="lg" className="w-full" render={<Link to="/sign-in" />} nativeButton={false}>
        Back to Sign In
      </Button>
    </CenteredAuthLayout>
  );
}
